module.exports = __webpack_public_path__ + "static/media/banner-disclamer.59578240.png";